import { render, staticRenderFns } from "./navigationCirle.vue?vue&type=template&id=1523cf74&scoped=true"
import script from "./navigationCirle.vue?vue&type=script&lang=ts"
export * from "./navigationCirle.vue?vue&type=script&lang=ts"
import style0 from "./navigationCirle.vue?vue&type=style&index=0&id=1523cf74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1523cf74",
  null
  
)

export default component.exports